import hrMessages from '../locales/hr_HR.json';

const HrLang = {
  messages: {
    ...hrMessages,
  },
  locale: 'hr-HR',
};
export default HrLang;
